import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Icon from 'components/Icon';
import { isInternalLink } from 'helpers/ContentHelper';
import { helperGoToRelativeUrl } from 'helpers/RouteHelper';
import { fetchArticle } from 'components/Article/ArticleActions';
import { getArticleApiUrl } from 'components/Article/ArticleHelpers';
import Divider from '../Divider';
import Heading from '../Heading';
import Style from './Links.module.scss';

const SeriesLink = ({ url, isArticle, headline, accessToken, siteScanUrl }) => {
  const navigateToURL = () => {
    if (isArticle) {
      fetchArticle(getArticleApiUrl(url), accessToken);
    } else if (isInternalLink(url)) {
      helperGoToRelativeUrl(url);
    }
  };
  const linkProps = {
    onClick: navigateToURL,
    to: isArticle ? `/${siteScanUrl}/` : url,
    target: isArticle ? null : '_blank',
    className: Style.link,
  };
  return (
    <Link {...linkProps}>
      <div className={Style.icon}>
        {isArticle ? (
          <Icon color="white" viewBox="0 0 24 24" icon="article" />
        ) : (
          <Icon color="white" viewBox="0 0 24 24" icon="external-link-square-alt2" />
        )}
      </div>
      <div className={Style.title}>{headline}</div>
    </Link>
  );
};

// TODO: use Selectors to pull these component props
const Links = ({ links, accessToken }) => {
  const { seriesDetail_linksLabel: linksLabel = 'Links' } = window.Language;
  if (links.length === 0) return null;
  return (
    <>
      <section className={Style.links}>
        <Heading title={linksLabel} />
        <div className={Style.wrapper}>
          {links.map(link => (
            <SeriesLink {...link} key={link.id} accessToken={accessToken} />
          ))}
        </div>
      </section>
      <Divider />
    </>
  );
};

SeriesLink.defaultProps = {
  headline: '',
  isArticle: false,
  onClick: () => {},
  url: '',
};

SeriesLink.propTypes = {
  accessToken: PropTypes.string,
  headline: PropTypes.string,
  isArticle: PropTypes.bool,
  onClick: PropTypes.func,
  siteScanUrl: PropTypes.string,
  url: PropTypes.string,
};

Links.defaultProps = {
  links: [],
  accessToken: '=',
};

Links.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({})),
  accessToken: PropTypes.string,
};

export default React.memo(Links);
